module.exports = __webpack_public_path__ + "static/media/bag.aad4374b.jpg";